module.exports = __webpack_public_path__ + "static/media/logo-universiteit-utrecht.ec5dd716.png";